<template>
    <div class="data-evaluation-page">
        <!-- 企业主体合规 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>企业主体合规</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="5">
                    <div style="margin-bottom: 10px;">
                        <span style="color: red;">*</span> 资质证明材料：
                        资质证书或经营许可证书
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="handleZiZhiFileChange"
                        :on-remove="handleZiZhiRemove" :file-list="ziZhiFiles" :limit="10" :multiple="true"
                        accept=".pdf,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据合规 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据合规</span>
            </div>
            <!-- 数据来源证明材料： -->
            <el-row :gutter="20">
                <el-col :span="5">
                    <div style="margin-bottom: 10px;">
                        <span style="color: red;">*</span>
                        数据来源证明材料：
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="handleLaiYuanFileChange"
                        :on-remove="handleLaiYuanRemove" :file-list="laiYuanFiles" :limit="10" :multiple="true"
                        accept=".pdf,.doc,.docx,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 DOC、DOCX、PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="7">
                    注：根据数据来源不同，上传对应的材料<br>
                    原始取得：<br>
                    须提交设备/系统的买卖或租赁合同。<br>

                    如若系统为企业自己研发， 可提交软件著作权登记证书。<br>

                    继受所得：<br>
                    须提交权利转移相关的合同、合作协议、授权文书等。<br>

                    交易所得：<br>
                    须提交数据交易的凭证。<br>
                </el-col>
            </el-row>

            <!-- 添加单选框控制脱敏处理 -->
            <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="24">
                    <span style="color: red;">*</span> 数据是否涉及隐私、敏感数据：
                    <el-radio-group v-model="needBeProcessed" style="margin-left: 20px;">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-col>
            </el-row>

            <!-- 数据脱敏处理证明材料 -->
            <el-row :gutter="20" style="margin-top: 50px;" v-if="needBeProcessed">
                <el-col :span="5">
                    <div style="margin-bottom: 10px;">
                        <span style="color: red;">*</span> 数据脱敏处理证明材料：
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="handleYinSiFileChange"
                        :on-remove="handleYinSiRemove" :file-list="yinSiFiles" :limit="10" :multiple="true"
                        accept=".pdf,.xls,.xlsx,.jpg,.png,.jpeg">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 pdf,图片,Excel 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="7">
                    注：<br>
                    数据不涉及隐私、敏感数据：无需脱敏。<br>
                    数据涉及隐私、敏感数据：<br>
                    需提供100条数据脱敏样例。<br>
                    <span style="color: red;">*</span> 上传 Excel 表
                </el-col>
            </el-row>

            <!-- 数据存储安全证明材料 -->
            <el-row :gutter="20" style="margin-top: 50px;">
                <el-col :span="24">

                    <span style="color: red;">*</span> 数据存储方式：
                    <el-radio-group v-model="isSelfStorage" style="margin-left: 20px;">
                        <el-radio :label="true">自行存储</el-radio>
                        <el-radio :label="false">非自行存储</el-radio>
                    </el-radio-group>

                </el-col>

            </el-row>
            <el-row :gutter="20" style="margin-top: 50px;">
                <el-col :span="5">
                    <div style="margin-bottom: 10px;">
                        <div style="margin-bottom: 10px;">
                            <span style="color: red;">*</span> 上传存储方式对应材料：
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="handleCunChuFileChange"
                        :on-remove="handleCunChuRemove" :file-list="cunChuFiles" :limit="10" :multiple="true"
                        accept=".pdf,.jpg,.png">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 PDF、JPG和PNG格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
                <el-col :span="7">
                    注：<br>
                                数据自行存储：
                                企业签署并上传《数据合规承诺书》。<br>
                                <el-link type="primary" :underline="true"
                                    @click="downloadTemplate('ComplianceCommitmentLetter.docx')">
                                    《自行存储合规承诺书》下载
                                </el-link>
                                <br>
                                <br>
                                非自行存储：
                                上传与第三方机构合作的相关租赁协议或合作协议。<br>
                                <el-link type="primary" :underline="true"
                                    @click="downloadOtherTemplate('OtherComplianceCommitmentLetter.docx')">
                                    《第三方存储合规承诺书》下载
                                </el-link>
                </el-col>
            </el-row>


        </el-card>

        <div style="margin-top: 30px; text-align: center;">
            <el-button type="danger" size="medium" @click="close('/DataCompliance')" :disabled="isSubmitting" style="width: 80px;">
                关闭
            </el-button>
            <el-button type="primary" size="medium" @click="submitEvaluation" :disabled="isSubmitDisabled"
                style="width: 150px;">
                {{ isSubmitting ? '提交中...' : '提交合规评估' }}
            </el-button>

        </div>
    </div>
</template>

<script>

export default {
    name: 'DataComplianceApply',
    data() {
        return {
            fileSizeLimit: 100, // 文件大小限制，单位MB
            allFileList: [],
            ziZhiFiles: [],
            laiYuanFiles: [],
            yinSiFiles: [],
            cunChuFiles: [],

            needBeProcessed: true,
            allFileUploaded: false,

            isSelfStorage: true,
            companyAndAssetInfo: {},
            registrationId: '',
            userId: '',
            uploadedFileUrls: [],
            fileTypesMap: new Map(), // 记录文件与其类型的映射关系
            isSubmitting: false, // 控制提交状态
             submitConfirmInstance: null, // 保存提交确认弹窗的引用

        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';
        this.userId = this.$route.query.userId || '';

        if (this.registrationId && this.userId) {

        }
    },
    methods: {
        formatDateTime(dateTime) {
            if (!dateTime) return '-'

            const date = new Date(dateTime)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')

            return `${year}-${month}-${day}`
        },

        validateFile(file, allowExcel = false, allowWord = false) {
            // 验证文件类型
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];

            // 如果允许Excel文件，则添加Excel相关类型
            if (allowExcel) {
                allowedTypes.push('application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                allowedExtensions.push('.xls', '.xlsx');
            }

            // 如果允许Word文件，则添加Word相关类型
            if (allowWord) {
                allowedTypes.push('application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                allowedExtensions.push('.doc', '.docx');
            }

            const fileTypeValid = allowedTypes.includes(file.raw.type);
            const fileExtensionValid = allowedExtensions.some(ext =>
                file.name.toLowerCase().endsWith(ext)
            );

            if (!fileTypeValid || !fileExtensionValid) {
                {
                    {
                        let message = '';
                        if (allowExcel && !allowWord) {
                            message = '只支持 Excel 格式的文件';
                        } else if (!allowExcel && allowWord) {
                            message = '只支持 Word 格式的文件';
                        } else if (allowExcel && allowWord) {
                            message = '只支持 Word 和 Excel 格式的文件';
                        } else {
                            message = '只支持 PDF、JPG 和 PNG 格式的文件';
                        }
                        this.$message.error(message);
                    }
                }
                return false;
            }

            // 验证文件大小
            const maxSize = this.fileSizeLimit * 1024 * 1024; // 转换为字节
            if (file.raw.size > maxSize) {
                this.$message.error(`文件大小不能超过 ${this.fileSizeLimit} MB`);
                return false;
            }

            return true;

        },
        // 资质文件上传
        handleZiZhiFileChange(file, fileList) {
            if (!this.validateFile(file)) {
                // 验证失败时，从文件列表中移除该文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            this.ziZhiFiles = fileList;
            this.allFileList.push(file);
        },

        // 移除资质文件
        handleZiZhiRemove(file, fileList) {
            // 从allFileList中移除对应的文件
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.ziZhiFiles = fileList;
        },


        // 来源文件上传
        handleLaiYuanFileChange(file, fileList) {
            if (!this.validateFile(file, false, true)) {
                // 验证失败时，从文件列表中移除该文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            this.laiYuanFiles = fileList;
            this.allFileList.push(file);

        },
        // 移除来源文件
        handleLaiYuanRemove(file, fileList) {
            // 从allFileList中移除对应的文件
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.laiYuanFiles = fileList;
        },
        // 隐私文件上传
        handleYinSiFileChange(file, fileList) {
            // 这个区域需要允许Excel文件上传
            if (!this.validateFile(file, true, false)) {
                // 验证失败时，从文件列表中移除该文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            this.yinSiFiles = fileList;
            this.allFileList.push(file);
        },
        // 移除隐私文件
        handleYinSiRemove(file, fileList) {
            // 从allFileList中移除对应的文件
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.yinSiFiles = fileList;
        },
        // 存储文件上传
        handleCunChuFileChange(file, fileList) {
            if (!this.validateFile(file)) {
                // 验证失败时，从文件列表中移除该文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return false;
            }
            this.cunChuFiles = fileList;
            this.allFileList.push(file);
        },
        // 移除存储文件
        handleCunChuRemove(file, fileList) {
            // 从allFileList中移除对应的文件
            const index = this.allFileList.indexOf(file);
            if (index > -1) {
                this.allFileList.splice(index, 1);
            }
            this.cunChuFiles = fileList;
        },



        // 模板下载
        async downloadTemplate(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('ComplianceCommitmentLetter.docx')) {
                    fileName = "数据资产合规承诺书.docx"
                }

                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }

        },
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },
        // 提交表单
        async submitEvaluation() {
            //防止重复提交
            if (this.isSubmitting) {
                return;
            }
            // 显示提交中弹窗 
            this.submitConfirmInstance = this.$loading({
                lock: true,
                text: '正在提交文件，请勿关闭或刷新页面...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // 设置提交状态
            this.isSubmitting = true;
            // 首先检查是否有文件需要上传
            if (this.allFileList.length === 0) {
                this.$message.warning('请至少上传一个文件');
                return;
            }

            try {
                // 逐个上传文件
                // this.$message.info('开始上传文件...');

                for (let i = 0; i < this.allFileList.length; i++) {
                    const file = this.allFileList[i];

                    // 确定文件类型
                    let fileType = '';
                    if (this.ziZhiFiles.includes(file)) {
                        fileType = 'qualificationMaterials';
                    } else if (this.laiYuanFiles.includes(file)) {
                        fileType = 'dataSourceMaterials';
                    } else if (this.yinSiFiles.includes(file)) {
                        fileType = 'dataSampleMaterials';
                    } else if (this.cunChuFiles.includes(file)) {
                        fileType = 'dataStorageMaterials';
                    }


                    // 上传单个文件
                    const response = await this.uploadSingleFile(file, fileType);

                    // 检查上传结果
                    if (response.data && response.data.status === 200 && response.data.object) {
                        console.log(response);
                        // 保存 URL 和文件类型
                        this.uploadedFileUrls.push({
                            url: response.data.object,
                            type: response.data.fileType || fileType
                        });
                        // this.$message.success(`文件 ${file.name} 上传成功 (${i + 1}/${this.allFileList.length})`);
                    } else {
                        throw new Error(`文件 ${file.name} 上传失败: ${response.data.msg || '未知错误'}`);
                    }
                }

                // // 所有文件上传成功后，提交表单数据
                const submitData = {
                    registrationId: this.registrationId,
                    qualificationMaterials: [],
                    dataSourceMaterials: [],
                    dataSampleMaterials: [],
                    dataStorageMaterials: [],
                    isSelfStorage: this.isSelfStorage,
                };

                // 根据文件上传区域将URL分配到正确的字段
                this.uploadedFileUrls.forEach(item => {
                    switch (item.type) {
                        case 'qualificationMaterials':
                            submitData.qualificationMaterials.push(item.url);
                            break;
                        case 'dataSourceMaterials':
                            submitData.dataSourceMaterials.push(item.url);
                            break;
                        case 'dataSampleMaterials':
                            submitData.dataSampleMaterials.push(item.url);
                            break;
                        case 'dataStorageMaterials':
                            submitData.dataStorageMaterials.push(item.url);
                            break;
                    }
                });

                

                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataComplianceDetail/add', submitData);

                if (response.data && response.data.status === 200) {
                                       // 关闭提交中的弹窗
                    this.closeSubmitConfirm();
                    // 提交成功后显示确认弹窗
                    this.$confirm('提交成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataCompliance');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }


            } catch (error) {
                this.$message.error('文件上传或提交失败: ' + (error.message || '未知错误'));
            }
        },

                // 关闭提交确认弹窗的方法
        closeSubmitConfirm() {
            if (this.submitConfirmInstance) {
                this.submitConfirmInstance.close();
                this.submitConfirmInstance = null;
            }
        },
        // 单个文件上传方法
        uploadSingleFile(file, fileType) {
            const formData = new FormData();
            formData.append('file', file.raw || file);
            formData.append('registrationId', this.registrationId);
            formData.append('type', fileType);

            return this.$axios.post('/web/dataComplianceDetail/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                // 在响应中添加文件类型信息
                if (response.data && response.data.status === 200 && response.data.object) {
                    response.data.fileType = fileType; // 添加文件类型标识
                }
                return response;
            });
        }
    },
    computed: {

        isSubmitDisabled() {
            // 检查所有必需的文件列表是否都已上传文件
            const hasZiZhiFiles = this.ziZhiFiles && this.ziZhiFiles.length > 0;
            const hasLaiYuanFiles = this.laiYuanFiles && this.laiYuanFiles.length > 0;
            const hasYinSiFiles = (!this.needBeProcessed) || (this.yinSiFiles && this.yinSiFiles.length > 0);
            const hasCunChuFiles = this.cunChuFiles && this.cunChuFiles.length > 0;
            console.log(this.allFileList);

            return this.isSubmitting || !(hasZiZhiFiles && hasLaiYuanFiles && hasYinSiFiles && hasCunChuFiles);
        }
    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-form-item>>>.el-form-item__label {
    color: #666;
    font-weight: normal;
}

</style>